// extracted by mini-css-extract-plugin
module.exports = {"container":"_2kJTEWDGDpUtcfNbmBvk0r","visible":"fwM3LSe_tdXh7Sr2uB3xn","cancelBtn":"_3pykg3blU8lpTUzqfz-WDf","icon":"_3n8gyJacxwZ8ev-ZdrgRZH","saveBtn":"_12zTev_xqCSGTjGZHE75ep"};